import ProdutoModel from 'models/Produto';

export default function alterarNomeProdutos(
  produtos?: ProdutoModel[],
): ProdutoModel[] {
  if (!produtos) return [];

  return produtos.map(produto => ({
    ...produto,
    nome: `${produto.nome} (${produto.ProdutoCategoria?.descricao})`,
  }));
}
